// Fase 17.3, Plano 08 — regras puras da tela de modelos de roteiro (sem React).
import type { FichaPecaRoteiroDto, ImpactoModeloRoteiroDto, ServicoComCelulasDto } from '@pieltec/contracts';
import type { EtapaEdicao } from './etapas';

function quantidade(valor: number, singular: string, plural: string): string {
  return `${valor} ${valor === 1 ? singular : plural}`;
}

/** Frase do diálogo de confirmação: quem recebe a nova versão e quem fica como está (D-17). */
export function resumoImpacto(impacto: Pick<ImpactoModeloRoteiroDto, 'pecasQueSeguem' | 'pecasQueDiferem'>): string {
  const seguem = impacto.pecasQueSeguem;
  const diferem = impacto.pecasQueDiferem;
  const primeira = seguem === 0
    ? 'Nenhuma peça segue este modelo agora.'
    : seguem === 1 ? '1 peça que segue este modelo vai receber a nova versão.' : `${quantidade(seguem, 'peça', 'peças')} que seguem este modelo vão receber a nova versão.`;
  const segunda = diferem === 0
    ? 'Nenhuma peça tem ajuste próprio.'
    : diferem === 1 ? '1 peça com ajuste próprio não muda.' : `${quantidade(diferem, 'peça', 'peças')} com ajuste próprio não mudam.`;
  return `${primeira} ${segunda}`;
}

/** Mensagem de sucesso depois de salvar o modelo. */
export function mensagemDoResultado(resultado: { readonly codigo: string; readonly versao: number; readonly pecasAtualizadas: number }): string {
  const pecas = resultado.pecasAtualizadas === 0 ? 'Nenhuma peça foi atualizada.' : `${quantidade(resultado.pecasAtualizadas, 'peça atualizada', 'peças atualizadas')}.`;
  return `Modelo ${resultado.codigo} salvo na versão ${resultado.versao}. ${pecas}`;
}

/** Prévia da sequência de serviços do modelo: "Banho aço carbono → Limpeza e Preparação → …". */
export function assinaturaDasEtapas(etapas: readonly Pick<EtapaEdicao, 'servicoId'>[], servicos: readonly Pick<ServicoComCelulasDto, 'id' | 'nome'>[]): string {
  return etapas.map((etapa) => servicos.find((servico) => servico.id === etapa.servicoId)?.nome ?? 'Serviço').join(' → ');
}

/** "Voltar a seguir o modelo" só faz sentido para quem gerencia roteiros e numa peça que difere do modelo a que está ligada (D-17). */
export function podeVoltarAoModelo(ficha: Pick<FichaPecaRoteiroDto, 'roteiro'>, permissoes: readonly string[]): boolean {
  const roteiro = ficha.roteiro;
  return permissoes.includes('roteiros:gerenciar') && roteiro !== null && roteiro.modelo !== null && roteiro.difereDoModelo;
}
